import { useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import { GoalsDialog } from "./components/goals/goal-dialog";
import { ProposalsDialog } from "./components/proposals/proposal-dialog";

export function Dialogs() {
  const search = useSearch({
    from: Route.id,
  });

  if (search.modal === "proposal") {
    return <ProposalsDialog />;
  }

  if (search.modal === "goals") {
    return <GoalsDialog />;
  }

  return null;
}
